export default __webpack_public_path__ + "static/Instagram-c9812402a1fda150042282cfe5d91adb.svg";